import { PremiumHistoryPeriods } from './types';

export const premiumPeriods: PremiumHistoryPeriods[] = [
  '7 days',
  '15 days',
  '30 days',
];
